module.exports = __webpack_public_path__ + "static/img/6-01.86f00d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/6-01.png
// module id = 3y4u
// module chunks = 1